module.exports = __webpack_public_path__ + "img/word-map.db521c45.png";